import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemApp } from '../constans/SystemConfigurations';
import {ApiUrl} from "../shared/models/apiurl.models";

export interface SocialLink {
  id: number;
  platform: string;
  platform_display: string;
  url: string;
  order: number;
  is_active: boolean;
}

export interface BusinessHour {
  id: number;
  day: string;
  day_display: string;
  open_time: string | null;
  close_time: string | null;
  is_closed: boolean;
}

export interface CompanyInfo {
  id: number;
  name: string;
  tagline: string;
  description: string;
  logo: string | null;
  cover_image: string | null;
  favicon: string | null;
  email: string;
  phone: string;
  whatsapp: string;
  address: string;
  city: string;
  founded_year: number | null;
  website: string;
  updated_at: string;
  social_links: SocialLink[];
  business_hours: BusinessHour[];
  // SEO
  seo_title:          string;
  seo_description:    string;
  seo_keywords:       string;
  seo_og_image:       string | null;
  seo_twitter_handle: string;
  seo_site_url:       string;
}

export interface FAQ {
  id: number;
  question: string;
  answer: string;
  order: number;
  is_active: boolean;
}

export interface ContactFormData {
  full_name: string;
  email: string;
  subject?: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private get options() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.apiKey.getJWTToken()
      })
    };
  }
  private readonly infoUrl    = `${SystemApp.base_url_api}/company-api/profile/info/`;
  private readonly faqUrl     = `${SystemApp.base_url_api}/company-api/faq/`;
  private readonly contactUrl = `${SystemApp.base_url_api}/company-api/contact/`;

  constructor(private http: HttpClient, private apiKey: ApiUrl) {}

  // Public endpoint (AllowAny on the backend) - guests need it for SEO tags,
  // /contact, /about and the chatbot contact card, so it is not gated on login
  // and sends no hand-built Authorization header (AppInterceptor still adds
  // the token when a user is signed in).
  getCompanyInfo(): Observable<CompanyInfo> {
    return this.http.get<CompanyInfo>(this.infoUrl);
  }

  getFAQs(): Observable<FAQ[]> {
    return this.http.get<FAQ[]>(this.faqUrl);
  }

  submitContact(data: ContactFormData): Observable<{ detail: string }> {
    return this.http.post<{ detail: string }>(this.contactUrl, data, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }
}
